import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import notify from 'devextreme/ui/notify';
import { environment } from '../environments/environment';
import * as Papa from 'papaparse/papaparse.min.js';
declare var $: any;
import * as CryptoJS from 'crypto-js';
import { Constants } from './constants';
import { map, catchError, throwError } from 'rxjs';
import { Router } from '@angular/router';


@Injectable()
export class UtilityService {

  constructor(private http: HttpClient, private oRouter: Router) {
    this.GetSystemSetting();
  }
  //Start - Most common methods used across the portal

  public EncodeNewLineTabCharacters(sData: string) {
    return sData.replace(/\n/g, 'neewwlliine').replace(/\r/g, 'neewwlliine').replace(/\t/g, 'TaaaabbbbKy');
  }

  public ReplaceNewLineTabCharacters(sData: string) {
    return sData.replace(/DooobleQuote/g, '"').replace(/neewwlliine/g, '\n').replace(/BaccckSlash/g, '\\').replace(/TaaaabbbbKy/g, '\t');
  }

  public EscapeCharacters(sData: string) {
    return sData.replace(/neewwlliine/g, '  ').replace(/BaccckSlash/g, '\\\\').replace(/TaaaabbbbKy/g, '  ').replace(/quoootes/g, '\\"').replace(/backslaaash/g, "\\\\");
  }

  strTrueValue: string = 'true';
  strFalseValue: string = 'false';
  public IsNullOrEmpty(sValue: string) {
    if (sValue === undefined || sValue === '' || sValue === null /*|| sValue.trim() == ''*/) { // FB 26903 - Vidya
      return true;
    }
    else {
      return false;
    }
  }

  public IsNullOrUndefined(iValue: any) {
    if (iValue === undefined || iValue === null) {
      return true;
    }
    else {
      return false;
    }
  }

  public IsTrue(oValue: any) {
    if (oValue === 1 || oValue.toString().toLowerCase() === this.strTrueValue) {
      return true;
    }
    else {
      return false;
    }
  }

  private GetKey()
  {
    return "Cuuube Looogic19";
  }

  public GetBasewebAPIURL(): string {
    let hostname: string;
    let documentURL: string;
    let urlAarray: any;
    let baseURL: any;
    console.log("environment?.ISDOCKER " + environment?.ISDOCKER);
    console.log("environment?.RISKCUBEDAPI " + environment?.RISKCUBEDAPI);
    if (environment?.ISDOCKER) {
      return environment?.RISKCUBEDAPI + "/";
    }
    if (environment.webapiendpoint.toString().toLocaleLowerCase() != "dev") {
      //prod endpoint
      let hostname: string = document.location.origin + "/";
      let documentURL: string = document.URL // get the document path
      let urlAarray: any = documentURL.split("/")
      let baseURL: any = hostname + urlAarray[3] + "/RiskCubedAPI/"; // Get the  virtual directory  and append it

      return baseURL;
    }
    else {
      //Dev endpoint
      baseURL = "https://localhost:52109/"
      return baseURL;
    }
  }
  SystemSettings: any;
  public GetSystemSetting() {
    if (this.IsNullOrUndefined(this.SystemSettings)) {
      this.getDataByPromise(this.GetBasewebAPIURL() + "api/CallMemo/SystemSetting").then((Data) => {
        if (Data != null) {
          this.SystemSettings = Data[0];
        }
      });
    }
    return this.SystemSettings;
  }


  getDataByPromise(getURI: string): Promise<any> {
    let headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let options = { headers: headers, withCredentials: true };
    //FB 6060 SSO Integration
    //if (environment.SSOEnabled) {
    //  options = null;
    //  options = new RequestOptions({ headers: headers });
    //}

    return this.http
      .get(getURI, options) //.map((response:Response)=><any>response.json())
      .pipe(
        map((data: any) => {
          return JSON.parse(JSON.stringify(data));
        }),
        catchError((error) => {
          this.redirectToUnauthorize(error.error);
          return throwError(this.handleError);
        }))
      .toPromise()
      .then(this.extractData)
      .catch(this.handleError);
  }


  redirectToUnauthorize(data: any) {
    if (
      this.redirectToUnauthorizePage(data)
    ) {
      this.oRouter.navigate(['/UnAuthorized/' + data]);
    }
  }

  redirectToUnauthorizePage(data: any) {
    if (
      data === 'Authorization has been denied for this request' ||
      data.indexOf('Authorization has been denied') > -1 ||
      data === 'Authorization has been denied because of Token Expiry'
    ) {
      return true
    } else {
      return false;
    }
  }
  private extractData(res: Response): any {
    let body = JSON.parse(JSON.stringify(res));
    return body || [];
  }

  private handleError(error: any) {
    // In a real world app, we might use a remote logging infrastructure
    // We'd also dig deeper into the error to get a better message
    let errMsg = error.message
      ? error.message
      : error.status
        ? `${error.status} - ${error.statusText}`
        : 'Server error';
    console.error(errMsg); // log to console instead
    return throwError(error);
  }

  public ReplaceOriginalCharacters(sDataValue: string) {
    if (sDataValue != null) {
      sDataValue = sDataValue.replace(/frontslaaash/g, "/").replace(/hassh/g, "#").replace(/exclammmaation/g, "!").replace(/backslaaash/g, "\\")
        .replace(/aaat/g, "@").replace(/dolllaar/g, "$").replace(/perseent/g, "%").replace(/annnd/g, "&").replace(/staaar/g, "*").replace(/pluuuus/g, "+")
        .replace(/leeesthan/g, "<").replace(/greeeterthan/g, ">").replace(/quoootes/g, "\"").replace(/DooobleQuote/g, '"').replace(/neewwlliine/g, '\n').replace(/BaccckSlash/g, '\\');;
    }

    return sDataValue;
  }

  //Converting to Date string to Locale string
  public ConvertToDate(sDate: any) {
    let date;
    date = this.toLocalISODate(new Date(sDate));
    return date;
  }

public formatDate(sDate) {
      const date = new Date(sDate);
      return date.toISOString().split('.')[0]; // Converts to "2025-04-15T00:00:00.000Z"
  }

  //END - Most common methods used across the portal
  public ConvertToUniversalDateFormat(sDate: Date) {
    let dtFromDateConversion = new Date(sDate);
    let fromDate = dtFromDateConversion.getDate();
    if (fromDate != null) {
      let _oDateValue: any = fromDate < 10 ? "0" + fromDate : fromDate;
      fromDate = _oDateValue;
    }
    let fromMonth = dtFromDateConversion.getMonth() + 1;
    if (fromMonth != null) {
      let _oMonthValue: any = fromMonth < 10 ? "0" + fromMonth : fromMonth;
      fromMonth = _oMonthValue;
    }
    let fromYear = dtFromDateConversion.getFullYear();

    return fromYear + "-" + fromMonth + "-" + fromDate;
  }


  // Common notify method
  public Notify(sMessage: string, sType: string) {
    let oWidgetOptions = {
      message: sMessage,
      closeOnClick: true
    };
    notify(oWidgetOptions, sType, 5000);
    return true;
  }

  // CSV Parcer

  public ParseCSVStringToStringArray(sCSVString: string): any {

    let oResult: any = Papa.parse(sCSVString, { delimiter: ",", quoteChar: "\"", escapeChar: "\\" });
    return oResult.data[0];

  }

  public ParseStringArrayToCSVString(oStringArray: any): string {

    let oArrayOfString: any = [];
    oArrayOfString.push(oStringArray);
    let CSVString: string = Papa.unparse({ data: oStringArray }, { delimiter: ",", quoteChar: "\"", escapeChar: "\\" });
    return CSVString;
  }
  //Encode escape characters missed by encodeURIComponent
  public superEncodeURI(url) {
    var encodedStr = '', encodeChars = ['-', '_', '.', '!', '~', '*', "'", '(', ')'];
    url = encodeURIComponent(url);

    for (var i = 0, len = url.length; i < len; i++) {
      if (encodeChars.indexOf(url[i]) >= 0) {
        var hex = parseInt(url.charCodeAt(i)).toString(16);
        encodedStr += '%' + hex;
      }
      else {
        encodedStr += url[i];
      }
    }
    return encodedStr;
  }
  //function to encode url
  URLEncode(str: any): string {
    let strToBeReturned = "";
    if (str != null && str != undefined && str != "") {
      strToBeReturned = str.toString().replace(/\%/g, '%25').replace(/&/g, '%26').replace(/#/g, '%23').replace(/\?/g, '%3F').replace(/\//g, '%2F').replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/\' '/g, "%20").replace(/\;/g, "%3B").replace(/\=/g, "%3D");
    }
    else {
      strToBeReturned = str;
    }
    return strToBeReturned;

  }
  public URLDecode(str: any): string {
    let strToBeReturned = "";
    //strToBeReturned = str.replace(/&/g, '%26');
    if (str != null && str != undefined && str != "") {
      strToBeReturned = str.toString().replace(/\%25/g, "%").replace(/\%26/g, "&").replace(/\%23/g, "#").replace(/\%3F/g, "?")
        .replace(/\%2F/g, "/").replace(/\%28/g, "(").replace(/\%29/g, ")").replace(/\%20/g, " ");
      //.replace(/\\/g, '%2F');//.replace(/</g, "%3C").replace(/>/g, "%3E").replace(/&/g, "%26").replace(/!/g, "%21").replace(/@/g, "%40").replace(/#/g, "%23").replace(/\$/g, "%24").replace(/\%/g, "%25").replace(/\^/g, "%5E").replace(/\*/g, "%2A").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/-/g, "%2D").replace(/\+/g, "%2B").replace(/=/g, "%3D").replace(/:/g, "%3A").replace(/;/g, "%3B").replace(/\?/g, "%3F").replace(/~/g, "%7E").replace(/\./g, "%2E").replace(/,/g, "%2C").replace(/\//g, "%2F").replace(/{/g, "%7B").replace(/}/g, "%7D").replace(/\[/g, "%5B").replace(/]/g, "%5D");//.replace(/'/g, "Quotes1").replace(/`/g, "Tilde2");
      //strToBeReturned = str.toString().replace(/\%/g, '%25').replace(/&/g, '%26').replace(/#/g, '%23').replace(/\?/g, '%3F').replace(/\//g, '%2F');//.replace(/\\/g, '%2F');//.replace(/</g, "%3C").replace(/>/g, "%3E").replace(/&/g, "%26").replace(/!/g, "%21").replace(/@/g, "%40").replace(/#/g, "%23").replace(/\$/g, "%24").replace(/\%/g, "%25").replace(/\^/g, "%5E").replace(/\*/g, "%2A").replace(/\(/g, "%28").replace(/\)/g, "%29").replace(/-/g, "%2D").replace(/\+/g, "%2B").replace(/=/g, "%3D").replace(/:/g, "%3A").replace(/;/g, "%3B").replace(/\?/g, "%3F").replace(/~/g, "%7E").replace(/\./g, "%2E").replace(/,/g, "%2C").replace(/\//g, "%2F").replace(/{/g, "%7B").replace(/}/g, "%7D").replace(/\[/g, "%5B").replace(/]/g, "%5D");//.replace(/'/g, "Quotes1").replace(/`/g, "Tilde2");
    }
    else {
      strToBeReturned = str;
    }
    return strToBeReturned;
    //&#%?/
  }

  public ReplaceSpecialCharacters(sDataValue: string) {
    if (sDataValue != null) {
      sDataValue = sDataValue.replace(/\//g, "frontslaaash").replace(/#/g, "hassh").replace(/!/g, "exclammmaation").replace(/\\/g, 'backslaaash')
        .replace(/@/g, "aaat").replace(/\$/g, "dolllaar").replace(/%/g, "perseent").replace(/&/g, "annnd").replace(/\*/g, "staaar").replace(/\+/g, "pluuuus")
        .replace(/</g, "leeesthan").replace(/>/g, "greeeterthan").replace(/\"/g, "quoootes").replace(/\?/g, "Questionmaaark").replace(/:/g, "cln100").replace(/\./g, "d0t");
    }

    return sDataValue;
  }


  ///validates email fields
  IsEmail(inputEmail: string): boolean {
    var mailstringarray = inputEmail.split(';');
    for (var i = 0; i < mailstringarray.length; i++) {
      var re = new RegExp(/^([a-zA-Z0-9_\-\.#]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{2,63}|[0-9]{1,3})(\]?)$/);
      if (re.test(mailstringarray[i]))
        return (true);
      else return (false);
    }
  }
  // Encrypt String using CryptoJS - Compatible with C# EncryptStringAES
  public EncryptStringAES(sValue: string, sKey: string): string {
    try {
      // Convert key to bytes exactly as C# does: Encoding.UTF8.GetBytes
      const keyBytes = CryptoJS.enc.Utf8.parse(sKey);
      const ivBytes = CryptoJS.enc.Utf8.parse(sKey);
      const key = this.ensureKeySize(keyBytes, 16);  // Use 128-bit (16 bytes) key
      const iv = this.ensureKeySize(ivBytes, 16);    // Use 128-bit (16 bytes) IV

      const encrypted = CryptoJS.AES.encrypt(sValue, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

      return encrypted.toString();
    } catch (error) {
      console.error('EncryptStringAES error:', error);
      if (error instanceof Error) {
        throw new Error('Encryption failed: ' + error.message);
      }
      throw new Error('Encryption failed: Unknown error');
    }
  }

  // Decrypt String using CryptoJS - Compatible with C# DecryptStringAES
  public DecryptStringAES(sValue: string, sKey: string): string {
    try {
      const keyBytes = CryptoJS.enc.Utf8.parse(sKey);
      const ivBytes = CryptoJS.enc.Utf8.parse(sKey);

      const key = this.ensureKeySize(keyBytes, 16);  // Use 128-bit (16 bytes) key
      const iv = this.ensureKeySize(ivBytes, 16);    // Use 128-bit (16 bytes) IV

      const decrypted = CryptoJS.AES.decrypt(sValue, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });
      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error('DecryptStringAES error:', error);

      if (error instanceof Error) {
        if (error.message.includes('Malformed UTF-8')) {
          throw new Error('Decryption failed: Invalid key or corrupted data');
        }
        throw new Error('Decryption failed: ' + error.message);
      }
      throw new Error('Decryption failed: Unknown error');
    }
  }

  // Helper method: Truncate or pad key to exact size
  private ensureKeySize(wordArray: CryptoJS.lib.WordArray, byteLength: number): CryptoJS.lib.WordArray {
    const currentBytes = wordArray.sigBytes;

    if (currentBytes === byteLength) {
      return wordArray;
    } else if (currentBytes > byteLength) {
      // Truncate to required size (take first N bytes)
      return CryptoJS.lib.WordArray.create(
        wordArray.words.slice(0, Math.ceil(byteLength / 4)),
        byteLength
      );
    } else {
      // Pad with zeros if too short
      const paddingLength = byteLength - currentBytes;
      const padding = CryptoJS.lib.WordArray.create(new Array(paddingLength).fill(0));
      return wordArray.clone().concat(padding);
    }
  }
  public EncryptString(sValue : string)
  {
    var key = CryptoJS.enc.Utf8.parse(this.GetKey());
    var iv = CryptoJS.enc.Utf8.parse(this.GetKey());

    var oKey = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(sValue), key,
      {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7
      });

    return oKey.toString();
  }
  public SpliceGridToolbarButtons(e: any) {
    //Remove save/discard changes button from toolbar
    e.toolbarOptions.items.splice(e.toolbarOptions.items.findIndex(x => x.name == 'saveButton'), 1);
    e.toolbarOptions.items.splice(e.toolbarOptions.items.findIndex(x => x.name == 'revertButton'), 1);
  }
  public GetTimeZone() {
    let sTimeZoneName: string = "";
    let TimeZoneOptions = new Date().toLocaleDateString(Constants.LOCALE_EN_US, { day: '2-digit', timeZoneName: 'long', });
    if (!this.IsNullOrUndefined(TimeZoneOptions)) {
      let TimeZoneDetails = TimeZoneOptions.split(",");
      if (!this.IsNullOrUndefined(TimeZoneDetails) && TimeZoneDetails.length > 1) {
        sTimeZoneName = TimeZoneDetails[1].trim();
      }
    }
    return sTimeZoneName;
  }

  // Rounds a number to the specified decimal places using SSRS cascading rounding behavior
  // (round half away from zero, one decimal place at a time from right to left).
  // e.g. RoundAsSQL(10.5349, 2) => 10.5349 -> 10.535 -> 10.54
  public RoundAsSQL(value: number, decimals: number): number {
    if (value == null || isNaN(value)) {
      return value;
    }
    let sign = value < 0 ? -1 : 1;
    let absValue = Math.abs(value);
    // Determine the number of decimal places in the value
    let valueStr = absValue.toString();
    let dotIndex = valueStr.indexOf('.');
    let currentDecimals = dotIndex === -1 ? 0 : valueStr.length - dotIndex - 1;
    // Cascading rounding: round one decimal place at a time from right to left
    for (let d = currentDecimals - 1; d >= decimals; d--) {
      let shifted = Number(absValue + 'e' + d);
      absValue = Number(Math.round(shifted) + 'e-' + d);
    }
    return absValue * sign;
  }
  public getTokenKey(getBasewebAPIURL)
  {
    var tokenString='';
    try
    {
    if (environment.webapiendpoint.toString() != 'dev') {
      var baseURLParameter=getBasewebAPIURL.split('/');
      tokenString= baseURLParameter[baseURLParameter.indexOf('CubeLogicAPI')-1]+'_Token';
    } else {
      tokenString='localhost_Token';
    }
  }
  catch(exception)
  {
    console.log(exception)
  }
    return tokenString;
  }



  public generatedNumbers = [];

  public generateUniqueKey() {
  let number;
   do {
     number = Math.floor(Math.random() * 1000000) + 5000000;
  } while (this.generatedNumbers.includes(number));
  this.generatedNumbers.push(number);
  return number;
}

public toLocalISOString(date: Date): string {
   const pad = (n: number) => n.toString().padStart(2, '0');

   const year = date.getFullYear();
   const month = pad(date.getMonth() + 1);
   const day = pad(date.getDate());
   const hours = pad(date.getHours());
   const minutes = pad(date.getMinutes());
   const seconds = pad(date.getSeconds());

   return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  public toLocalISODate(date: Date): Date {
    let year = date.getFullYear();
    const month = date.getMonth(); // 0-based
    const day = date.getDate();

    // Correct 2-digit years: interpret them as current century
    // For example: if current year is 2026, "26" becomes 2026
    if (year < 100) {
      const currentYear = new Date().getFullYear();
      const centuryBase = Math.floor(currentYear / 100) * 100;
      year = centuryBase + year;
    }

    //return new Date(year, month, day); // This creates a local date at 00:00
    return new Date(Date.UTC(year, month, day));
  }
  public toLocalISODateMonthIncreasedbyOne(date: Date): Date {
    const year = date.getFullYear();
    const month = date.getMonth()+1; // 0-based
    const day = date.getDate();

    return new Date(year, month, day); // This creates a local date at 00:00
  }
  public toLocalISODateTime(date: Date): Date {
    const year = date.getFullYear();
    const month = date.getMonth();
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    return new Date(year, month, day, hours, minutes, seconds);
  }

public toLocalISODateString(date: Date): string {
   const pad = (n: number) => n.toString().padStart(2, '0');

   const year = date.getFullYear();
   const month = pad(date.getMonth() + 1);
   const day = pad(date.getDate());

   return `${year}-${month}-${day}`;
  }
public isValidDate(value: any): boolean {
    const date = new Date(value as string | number | Date);
    if (isNaN(date.getTime())) {
      return false;
    }
    const year = date.getFullYear();
    return year >= 1753 && year <= 9999;
  }
}
